module.exports = __webpack_public_path__ + "assets/images/container_phase2.9a3f71fa762441738a7bf257d88e34ab.svg";